"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _usePalette2 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      fonts = _useTheme.fonts,
      colors = _useTheme.colors;

  var _usePalette = (0, _usePalette2["default"])(),
      typography = _usePalette.typography;

  var title = typography.title,
      titleEmphasis = typography.titleEmphasis;
  return {
    root: {
      color: colors[title],
      '& strong': {
        color: colors[titleEmphasis]
      }
    },
    headline1: fonts.headline1,
    headline2: fonts.headline2,
    headline3: fonts.headline3,
    headline4: fonts.headline4
  };
};

__signature__(useStyles, "useTheme{{ fonts, colors }}\nusePalette{{ typography }}", function () {
  return [_useTheme2["default"], _usePalette2["default"]];
});

var Headline = function Headline(props) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'span' : _props$as,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'headline4' : _props$variant,
      inactive = props.inactive,
      other = (0, _objectWithoutProperties2["default"])(props, ["as", "variant", "inactive"]);
  var classes = useStyles();
  return (0, _core.jsx)(Element, (0, _extends2["default"])({
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, classes[variant]], ";label:Headline;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UZXh0L0hlYWRsaW5lLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1Q2tCIiwiZmlsZSI6Ii4uLy4uL3NyYy9UZXh0L0hlYWRsaW5lLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENTU09iamVjdCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5pbXBvcnQgdXNlUGFsZXR0ZSBmcm9tICcuLi9zdHlsZXMvUGFsZXR0ZVByb3ZpZGVyL3VzZVBhbGV0dGUnO1xuaW1wb3J0IHVzZVRoZW1lIGZyb20gJy4uL3N0eWxlcy91c2VUaGVtZSc7XG5pbXBvcnQgeyBHZW5lcmljQ29tcG9uZW50LCBXaXRoQXNQcm9wIH0gZnJvbSAnLi4vdHlwZXMvd2l0aC1hcy1wcm9wJztcblxuZXhwb3J0IHR5cGUgSGVhZGxpbmVWYXJpYW50ID0gJ2hlYWRsaW5lMScgfCAnaGVhZGxpbmUyJyB8ICdoZWFkbGluZTMnIHwgJ2hlYWRsaW5lNCc7XG5cbmV4cG9ydCB0eXBlIEhlYWRsaW5lUHJvcHM8VCBleHRlbmRzIEdlbmVyaWNDb21wb25lbnQgPSAnc3Bhbic+ID0gV2l0aEFzUHJvcDxUPiAmIHtcbiAgdmFyaWFudD86IEhlYWRsaW5lVmFyaWFudDtcbiAgaW5hY3RpdmU/OiBib29sZWFuO1xufTtcblxuY29uc3QgdXNlU3R5bGVzID0gKCk6IENTU09iamVjdCA9PiB7XG4gIGNvbnN0IHsgZm9udHMsIGNvbG9ycyB9ID0gdXNlVGhlbWUoKTtcblxuICBjb25zdCB7IHR5cG9ncmFwaHkgfSA9IHVzZVBhbGV0dGUoKTtcbiAgY29uc3QgeyB0aXRsZSwgdGl0bGVFbXBoYXNpcyB9ID0gdHlwb2dyYXBoeTtcblxuICByZXR1cm4ge1xuICAgIHJvb3Q6IHtcbiAgICAgIGNvbG9yOiBjb2xvcnNbdGl0bGVdLFxuICAgICAgJyYgc3Ryb25nJzoge1xuICAgICAgICBjb2xvcjogY29sb3JzW3RpdGxlRW1waGFzaXNdLFxuICAgICAgfSxcbiAgICB9LFxuICAgIGhlYWRsaW5lMTogZm9udHMuaGVhZGxpbmUxLFxuICAgIGhlYWRsaW5lMjogZm9udHMuaGVhZGxpbmUyLFxuICAgIGhlYWRsaW5lMzogZm9udHMuaGVhZGxpbmUzLFxuICAgIGhlYWRsaW5lNDogZm9udHMuaGVhZGxpbmU0LFxuICB9O1xufTtcblxuY29uc3QgSGVhZGxpbmUgPSA8VCBleHRlbmRzIEdlbmVyaWNDb21wb25lbnQgPSAnc3Bhbic+KHByb3BzOiBIZWFkbGluZVByb3BzPFQ+KSA9PiB7XG4gIGNvbnN0IHsgYXM6IEVsZW1lbnQgPSAnc3BhbicsIHZhcmlhbnQgPSAnaGVhZGxpbmU0JywgaW5hY3RpdmUsIC4uLm90aGVyIH0gPSBwcm9wcztcbiAgY29uc3QgY2xhc3NlcyA9IHVzZVN0eWxlcygpO1xuXG4gIHJldHVybiA8RWxlbWVudCBjc3M9e1tjbGFzc2VzLnJvb3QsIGNsYXNzZXNbdmFyaWFudF1dfSB7Li4ub3RoZXJ9IC8+O1xufTtcblxuZXhwb3J0IGRlZmF1bHQgSGVhZGxpbmU7XG4iXX0= */"))
  }, other));
};

__signature__(Headline, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Headline;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Headline.tsx");
  reactHotLoader.register(Headline, "Headline", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Headline.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Headline.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();